import moment from 'moment'

const dateFilter = { 
  'Hoje': [moment(), moment()], 
  'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
  'Esta Semana': [moment().startOf('week'), moment().endOf('week')],
  'Última Semana': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
  'Este Mês': [moment().startOf('month'), moment().endOf('month')] ,
  'Último Mês': [moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')],
} 

export default dateFilter
